import { styled } from '@mui/material';

// https://mui.com/material-ui/react-autocomplete/#grouped
export const GroupItems = styled('ul')({
  padding: 0,
});
